import type { IErrorResponse } from '@/types/apis/Error';
import type { TagListItem } from '@/types/apis/Tags';
import type { PaginationResponse } from '@/types/PaginationResponse';

import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import url from '@/statics/urls';

const useTags = ({
  category_id,
}: {
  category_id: string;
}): UseQueryResult<TagListItem[], IErrorResponse> => {
  return useQuery({
    queryKey: [`${url.tags}?type=content_bank&category_id=${category_id}`],
    select: (result: PaginationResponse<TagListItem>) => result.list,
  });
};
export default useTags;
